import React from 'react'
import styled from 'styled-components'
import { Text, Flex, Button, VectorRightIcon } from 'uikit'
import { useTranslation } from 'contexts/Localization'

const Model = styled.img`
  width: 280px;

  ${({ theme }) => theme.mediaQueries.md} {
    width: 350px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    width: 550px;
  }
`

const PurpleTitle = styled(Text)`
  font-size: 20px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-size: 25px;
  }
`

const Title = styled(Text)`
  font-size: 20px;

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 28px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    font-size: 30px;
  }
`

const Detail = styled(Text)`
  font-size: 14px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-size: 16px;
  }
`

const ButtonText = styled(Text)`
  font-size: 12px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-size: 18px;
  }
`

const Quality: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Flex
      mt={['50px', null, null, null, '170px']}
      justifyContent="space-between"
      mx="auto"
      alignItems="center"
      maxWidth="1240px"
      flexDirection={['column', null, null, null, null, 'row']}
    >
      <Model src="/images/home/earn-model.png" alt="earn-model" />
      <Flex flexDirection="column" alignItems="start" maxWidth={['100%', null, null, null, null, '500px']}>
        <PurpleTitle color="primary" fontWeight="600">
          {t('Earn')}
        </PurpleTitle>
        <Title fontWeight="600">{t('Passive income in our Farms, Pools, Vaults, and NFT Pools')}</Title>
        <Detail mt={['10px', null, '15px', null, '18px']} fontWeight="300" color="textSecondary">
          {t(
            'We offer a variety of methods for users to earn and compound. LP farms, Single Asset Staking Pools, Multi Pool, Vaults, and NFT Staking Pools. Choose one of our many different earning options!',
          )}
        </Detail>
        <Button
          as="a"
          href="https://docs.darkmatterdefi.com/products/farms"
          target="_blank"
          height="27px"
          mt={['30px', null, '40px', null, '60px']}
          variant="text"
          p="0"
          endIcon={<VectorRightIcon fill="#128DFF" />}
        >
          <ButtonText fontSize="18px" fontWeight="500" color="#128DFF">
            {t('Learn More about Earning')}
          </ButtonText>
        </Button>
      </Flex>
    </Flex>
  )
}

export default Quality
